// Central mock data for CVOLVE PRO — demo user Alex Morgan + ecosystem data.

export const DEMO = {
  seeker: { email: "alex@cvolve.pro", password: "demo1234" },
  recruiter: { email: "recruiter@cvolve.pro", password: "demo1234" },
};

export const CURRENCIES = [
  { code: "USD", symbol: "$" },
  { code: "EUR", symbol: "€" },
  { code: "GBP", symbol: "£" },
  { code: "CAD", symbol: "CA$" },
  { code: "AUD", symbol: "AU$" },
  { code: "INR", symbol: "₹" },
  { code: "SGD", symbol: "S$" },
  { code: "AED", symbol: "AED" },
  { code: "CHF", symbol: "CHF" },
  { code: "JPY", symbol: "¥" },
];

export const AVATARS = {
  alex: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwaGVhZHNob3RzfGVufDB8fHx8MTc4NzMyMjAxN3ww&ixlib=rb-4.1.0&q=85",
  c1: "https://images.unsplash.com/photo-1609436132311-e4b0c9370469?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxkaXZlcnNlJTIwcHJvZmVzc2lvbmFsJTIwaGVhZHNob3RzfGVufDB8fHx8MTc4NzMyMjAxN3ww&ixlib=rb-4.1.0&q=85",
  c2: "https://images.pexels.com/photos/33646670/pexels-photo-33646670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const passport = {
  name: "Alex Morgan",
  headline: "Product Analyst → Product Manager",
  location: "London · Remote",
  currentRole: "Product Analyst",
  years: 4.8,
  targetRole: "Product Manager",
  strength: 86,
  matchAvg: 88,
  skills: ["Product Strategy", "SQL", "Python", "SaaS", "Analytics", "Stakeholder Management", "Roadmapping", "Experimentation"],
  sections: [
    { key: "summary", title: "Summary", complete: true },
    { key: "experience", title: "Experience", complete: true },
    { key: "skills", title: "Skills", complete: true },
    { key: "education", title: "Education", complete: true },
    { key: "projects", title: "Projects", complete: false },
    { key: "certs", title: "Certifications", complete: false },
  ],
  experience: [
    { role: "Product Analyst", company: "Fluxpay", period: "2022 — Present", bullets: ["Owned analytics for checkout funnel, lifting conversion 14%", "Partnered with 3 squads to prioritise the SaaS roadmap"] },
    { role: "Data Analyst", company: "Brightline", period: "2020 — 2022", bullets: ["Built self-serve dashboards used by 120+ stakeholders", "Automated reporting saving 20 hrs/week"] },
  ],
};

export const careerIntelligence = {
  current: { title: "Product Analyst", level: 100 },
  next: { title: "Product Manager", fit: 91, salary: "$120k – $150k", readiness: "Ready in ~3 months" },
  future: { title: "Senior Product Manager", fit: 78, salary: "$160k – $200k", readiness: "Ready in ~18 months" },
  radar: [
    { skill: "Strategy", you: 72, target: 90 },
    { skill: "Discovery", you: 65, target: 88 },
    { skill: "Analytics", you: 94, target: 85 },
    { skill: "Delivery", you: 70, target: 86 },
    { skill: "Leadership", you: 55, target: 84 },
    { skill: "Comms", you: 74, target: 88 },
  ],
  gaps: [
    { skill: "Product Discovery", level: 65, note: "Run 2 discovery sprints" },
    { skill: "Stakeholder Leadership", level: 55, note: "Lead a cross-functional initiative" },
    { skill: "Roadmap Ownership", level: 60, note: "Own a quarterly roadmap" },
  ],
  steps: ["Complete Product Discovery track", "Lead one enterprise stakeholder programme", "Ship a roadmap you own end-to-end"],
};

export const jobs = [
  { id: "j1", role: "Product Manager", company: "Nimbus Labs", logo: "N", color: "#2563EB", location: "London, UK", model: "Hybrid", salary: "$135k", match: 94, skills: ["Roadmapping", "SaaS", "Analytics"], posted: "2d" },
  { id: "j2", role: "Senior Product Analyst", company: "Fluxpay", logo: "F", color: "#06B6D4", location: "Remote · EU", model: "Worldwide Remote", salary: "$120k", match: 91, skills: ["SQL", "Experimentation", "Strategy"], posted: "1d" },
  { id: "j3", role: "Product Manager, Growth", company: "Loopwork", logo: "L", color: "#8B5CF6", location: "Berlin, DE", model: "Onsite", salary: "€110k", match: 88, skills: ["Growth", "A/B Testing", "SaaS"], posted: "4d" },
  { id: "j4", role: "Group Product Manager", company: "Meridian", logo: "M", color: "#FF7F50", location: "Singapore", model: "Hybrid", salary: "$160k", match: 82, skills: ["Leadership", "Strategy", "B2B"], posted: "6h" },
  { id: "j5", role: "Product Owner", company: "Cedar", logo: "C", color: "#84CC16", location: "Toronto, CA", model: "Remote", salary: "$118k", match: 86, skills: ["Agile", "Discovery", "SQL"], posted: "3d" },
  { id: "j6", role: "AI Product Manager", company: "Vela", logo: "V", color: "#F9A8D4", location: "Dubai, UAE", model: "Onsite", salary: "$150k", match: 79, skills: ["AI", "Roadmapping", "Data"], posted: "5d" },
];

export const atsSeed = {
  score: 87,
  keywords_score: 78, skills_score: 86, experience_score: 90, formatting_score: 94, jd_alignment_score: 72,
  matched_keywords: ["Product Strategy", "SQL", "Analytics", "Stakeholder Management", "SaaS"],
  missing_keywords: ["Roadmap Ownership", "A/B Testing", "OKRs"],
  summary: "Strong analytical foundation with clean formatting. Add product-leadership language and quantified roadmap outcomes to close alignment.",
  recommendations: ["Quantify impact with metrics on your top 3 bullets", "Add a Product Leadership summary line", "Mirror the JD keyword 'roadmap ownership'"],
};

export const jdSeed = {
  jobDescription: "We're hiring a Product Manager to own the enterprise roadmap, manage senior stakeholders, and drive experimentation across our SaaS platform. Must have experience with A/B testing, OKRs and cross-functional leadership.",
  match_score: 74,
  mismatches: [
    "JD emphasises managing enterprise stakeholders — your CV shows analytics depth but limited leadership language.",
    "JD requires roadmap ownership — not yet explicit on your CV.",
    "JD asks for A/B testing & OKRs — present but understated.",
  ],
  questions: [
    "Have you directly managed enterprise stakeholders? Describe the scope and outcome.",
    "Have you owned a product roadmap end-to-end? What was the result?",
    "Give an example of an experiment (A/B test) that changed a product decision.",
  ],
};

export const autofillFields = [
  { label: "Full name", value: "Alex Morgan" },
  { label: "Email", value: "alex@cvolve.pro" },
  { label: "Phone", value: "+44 7700 900123" },
  { label: "Location", value: "London, UK" },
  { label: "Current title", value: "Product Analyst" },
  { label: "Years experience", value: "4.8" },
  { label: "Education", value: "BSc Economics, LSE" },
  { label: "Top skills", value: "Product Strategy, SQL, Analytics" },
  { label: "LinkedIn", value: "linkedin.com/in/alexmorgan" },
  { label: "Portfolio", value: "alexmorgan.dev" },
  { label: "Work authorization", value: "UK · EU (remote worldwide)" },
  { label: "Notice period", value: "1 month" },
  { label: "Desired salary", value: "$140k" },
  { label: "Current company", value: "Fluxpay" },
  { label: "Start availability", value: "Immediate" },
  { label: "Willing to relocate", value: "Yes" },
  { label: "Preferred work model", value: "Remote" },
  { label: "Nationality", value: "British" },
  { label: "Languages", value: "English, Spanish, German, French" },
  { label: "GitHub", value: "github.com/alexmorgan" },
  { label: "University", value: "London School of Economics" },
  { label: "Graduation year", value: "2019" },
  { label: "References", value: "Available on request" },
  { label: "Certifications", value: "Pragmatic PM, SQL Advanced" },
  { label: "Cover letter", value: "Auto-generated from Profile" },
  { label: "Preferred locations", value: "London, Remote, Berlin" },
];

export const cvLanguages = [
  { code: "EN", name: "English", flag: "🇬🇧", title: "Product Manager", summary: "Product leader turning data into shipped outcomes." },
  { code: "ES", name: "Español", flag: "🇪🇸", title: "Gerente de Producto", summary: "Líder de producto que convierte datos en resultados." },
  { code: "DE", name: "Deutsch", flag: "🇩🇪", title: "Produktmanager", summary: "Produktverantwortlicher, der Daten in Ergebnisse verwandelt." },
  { code: "FR", name: "Français", flag: "🇫🇷", title: "Chef de Produit", summary: "Leader produit transformant les données en résultats." },
];

export const interviewQuestions = [
  { id: "q1", q: "Tell me about a time you influenced a product decision with data.", tag: "Behavioural" },
  { id: "q2", q: "How would you prioritise a roadmap with conflicting stakeholder demands?", tag: "Product Sense" },
  { id: "q3", q: "Describe a failed experiment and what you learned.", tag: "Behavioural" },
];

export const kanban = {
  columns: ["Wishlist", "Saved", "Applied", "Assessment", "Interview", "Offer", "Rejected"],
  cards: {
    Wishlist: [{ id: "a1", role: "Group PM", company: "Meridian", match: 82 }],
    Saved: [{ id: "a2", role: "AI PM", company: "Vela", match: 79 }],
    Applied: [{ id: "a3", role: "Senior Product Analyst", company: "Fluxpay", match: 91 }, { id: "a4", role: "Product Owner", company: "Cedar", match: 86 }],
    Assessment: [{ id: "a5", role: "PM, Growth", company: "Loopwork", match: 88 }],
    Interview: [{ id: "a6", role: "Product Manager", company: "Nimbus Labs", match: 94 }],
    Offer: [],
    Rejected: [{ id: "a7", role: "PM", company: "Orbit", match: 61 }],
  },
};

export const analytics = {
  applications: 34, interviews: 7, offers: 2, responseRate: 41,
  weekly: [
    { week: "W1", applied: 4, interviews: 1 },
    { week: "W2", applied: 7, interviews: 2 },
    { week: "W3", applied: 6, interviews: 1 },
    { week: "W4", applied: 9, interviews: 3 },
    { week: "W5", applied: 8, interviews: 2 },
  ],
  funnel: [
    { stage: "Applied", value: 34 },
    { stage: "Screen", value: 15 },
    { stage: "Interview", value: 7 },
    { stage: "Offer", value: 2 },
  ],
};

// Recruiter side
export const candidates = [
  { id: "c1", name: "Priya Nair", role: "Senior Product Manager", location: "Bengaluru, IN", match: 95, skills: ["Roadmapping", "SaaS", "Discovery"], exp: "7 yrs", avatar: AVATARS.c1, status: "New" },
  { id: "c2", name: "Marcus Reid", role: "Product Manager", location: "Austin, US", match: 89, skills: ["Growth", "A/B Testing", "SQL"], exp: "5 yrs", avatar: AVATARS.c2, status: "Screening" },
  { id: "c3", name: "Alex Morgan", role: "Product Analyst", location: "London, UK", match: 88, skills: ["Analytics", "SQL", "Strategy"], exp: "4.8 yrs", avatar: AVATARS.alex, status: "New" },
  { id: "c4", name: "Sara Lindqvist", role: "Group Product Manager", location: "Stockholm, SE", match: 84, skills: ["Leadership", "B2B", "Strategy"], exp: "9 yrs", avatar: AVATARS.c1, status: "Interview" },
];

export const recruiterStats = { activeJobs: 6, candidates: 248, interviews: 18, hires: 4 };

export const pipeline = {
  columns: ["Sourced", "Screening", "Interview", "Offer", "Hired"],
  cards: {
    Sourced: [{ id: "p1", name: "Priya Nair", role: "Sr PM", match: 95 }, { id: "p2", name: "Alex Morgan", role: "Product Analyst", match: 88 }],
    Screening: [{ id: "p3", name: "Marcus Reid", role: "PM", match: 89 }],
    Interview: [{ id: "p4", name: "Sara Lindqvist", role: "Group PM", match: 84 }],
    Offer: [],
    Hired: [{ id: "p5", name: "Devin Cole", role: "PM", match: 90 }],
  },
};

export const comparison = {
  categories: ["CVOLVE", "Job Boards", "Pro Networks", "Resume Tools", "ATS Tools", "Interview Apps"],
  rows: [
    "Global Job Aggregation", "Onsite / Remote / Hybrid", "Worldwide Remote", "4-Language CV",
    "ATS Analysis", "JD Analysis", "Targeted Questions", "Customized CV", "Application Autofill",
    "Career Profile", "Career Intelligence", "STAR Interview Prep", "Face-to-Face Practice",
    "Application Tracking", "Recruiter Platform",
  ],
  // 0 = no, 1 = partial, 2 = yes
  matrix: {
    CVOLVE: [2,2,2,2,2,2,2,2,2,2,2,2,2,2,2],
    "Job Boards": [1,2,1,0,0,0,0,0,0,0,0,0,0,1,1],
    "Pro Networks": [1,1,0,0,0,0,0,0,0,1,0,0,0,0,1],
    "Resume Tools": [0,0,0,1,1,1,0,1,0,1,0,0,0,0,0],
    "ATS Tools": [0,0,0,0,2,1,0,0,0,0,0,0,0,0,0],
    "Interview Apps": [0,0,0,0,0,0,1,0,0,0,0,2,1,0,0],
  },
};

export const pricing = [
  {
    name: "FREE", price: "$0", period: "forever", accent: "aqua",
    tagline: "Start evolving your career",
    features: ["Career Profile", "5 job matches / day", "Basic ATS score", "1 CV language", "Application tracker"],
    cta: "Start Free",
  },
  {
    name: "PRO", price: "$19", period: "/month", accent: "electric", featured: true,
    tagline: "For serious job seekers",
    features: ["Everything in Free", "Unlimited global job matches", "Deep ATS + JD analysis", "AI CV customization", "4-language CV", "Application autofill", "Interview Copilot"],
    cta: "Go Pro",
  },
  {
    name: "CAREER MAX", price: "$39", period: "/month", accent: "violet",
    tagline: "Your full career team",
    features: ["Everything in Pro", "Face-to-Face interview practice", "Career Intelligence roadmap", "Priority recruiter visibility", "1:1 career strategy", "Salary negotiation coach"],
    cta: "Go Max",
  },
];

// Global map nodes [lng, lat]
export const mapNodes = [
  { name: "USA", coordinates: [-98, 39] },
  { name: "Canada", coordinates: [-106, 56] },
  { name: "UK", coordinates: [-1.5, 52] },
  { name: "Germany", coordinates: [10, 51] },
  { name: "UAE", coordinates: [54, 24] },
  { name: "India", coordinates: [78, 22] },
  { name: "Singapore", coordinates: [103.8, 1.3] },
  { name: "Australia", coordinates: [134, -25] },
];

export const mapLinks = [
  ["UK", "USA"], ["UK", "India"], ["Germany", "UAE"], ["India", "Singapore"],
  ["USA", "Canada"], ["Singapore", "Australia"], ["UAE", "India"], ["Germany", "UK"],
];
